import React, { useState } from 'react';
import { Button, Form, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import { useFluidForm } from '../FormContext';
import { FieldComponent } from './FieldComponent';
const FormContainer = styled.div.attrs({
    className: 'fluid-multi-field-form-container'
}) `
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  border: 1px solid #e1e5e9;
`;
const FormTitle = styled.h4.attrs({
    className: 'fluid-multi-field-form-title'
}) `
  margin: 0 0 12px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
`;
const SubmitButton = styled(Button).attrs({
    className: 'fluid-button-primary'
}) `
  width: 100%;
  margin-top: 8px !important;
`;
export const MultiFieldForm = ({ fields, data, onSubmit, isLoading = false }) => {
    const formConfigService = useFluidForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmit = async () => {
        let formData = {};
        for (let field of fields) {
            const value = formConfigService.getPlainValue(field)?.toString() || "";
            const fieldConfig = formConfigService.getConfig(field);
            const fieldLabel = fieldConfig?.label || field;
            // Store the formatted field in the result
            formData[fieldLabel] = value;
        }
        setIsSubmitting(true);
        try {
            await onSubmit(formData);
        }
        finally {
            // @TODO: FLU-193 Handle this.
            setIsSubmitting(false);
        }
    };
    const handleCancel = () => {
        // For now, just do nothing since we're showing the form inline
        // In the future, we could hide the form or show a different state
    };
    return (React.createElement(FormContainer, { className: "fluid-multi-field-form-container" },
        React.createElement(Form, null,
            fields.map((fieldName) => {
                return (React.createElement(FieldComponent, { key: fieldName, fieldPath: fieldName }));
            }),
            React.createElement("div", { style: { marginTop: '16px', display: 'flex', gap: '8px' } },
                React.createElement(SubmitButton, { primary: true, onClick: handleSubmit, loading: isSubmitting || isLoading, disabled: isSubmitting || isLoading },
                    React.createElement(Icon, { name: "check" }),
                    "Submit")))));
};
